<template>
    <b-modal
      id="modal-confirm-quick-payment"
      v-model="dialog"
      centered
      hide-header
    >
      <b-card-header class="header-banner">
       
        <div class="d-flex justify-content-between align-items-center block-header">
          <h5 class="mb-0 header-banner-title">
            {{ headerTitleModal}}
          </h5>
          <feather-icon
            icon="XIcon"
            size="24"
            class="cursor-pointer"
            @click="close"
          />
        </div>
      </b-card-header>
      <b-card-body>
        <b-overlay
          :show="isLoading"
          :opacity="0.3"
          rounded="sm"
        >
        <b-row>
          <b-col cols="12" class="confirm-span">
            <span>{{ $t('golf_confirm_quick_checkout_print_type_title') }}</span>
          </b-col>
          
        </b-row>
        <b-row>
          <b-col cols="2">
            <span class="confirm-quick-action-span">{{ $t('golf_booking_confirm_quick_checkout_print_type') }}</span>
          </b-col>
          <b-col cols="10">
            <v-select 
                    class="truncate-label"
                    v-model="paymentAction"
                    :options="paymentTypeOptions"
                    :placeholder="$t('golf_payment_payment_type')"
                    :clearable="false"
                    :searchable="false"
                    label="title"
                    :reduce="option => option.value"
                  />
          </b-col>
        </b-row>
        </b-overlay>
      </b-card-body>
      <template #modal-footer>
          <div>
            <b-button
              variant="primary"
              @click="confirmDialog"
              :disabled ="isLoading"
              class="mr-2"
            >
              {{ $t('golf_common_confirm') }}
            </b-button>
            <b-button
              
              variant="outline-secondary"
              @click="close"
              :disabled ="isLoading"
            >
              {{ $t('golf_common_cancel') }}
            </b-button>
           
          </div>
  
        </template>
    </b-modal>
  </template>
  
  <script>
import { booking } from '@/api/booking'

  export default {
    props:{
        Type: {
        type: String,
    },
    },

    data() {
      return {
        dialog: false,
        paymentAction : null,
        item: {
          dataConfirm: {
            title: 'abcass',
            content: 'bsaass',
            hideFooter: false,
          },
        },
        isLoading: false,
        isShowDetailListInvoice:true,
      }
    },
    watch: {
      dialog(value) {
        if(!value) {
          //this.$emit('cancelDialog', this.item)
        } else {
          this.paymentAction = this.paymentTypeOptions && this.paymentTypeOptions.length > 0 ? this.paymentTypeOptions[0].value : null
        }
      },
      Type(){
        this.paymentAction = this.paymentTypeOptions && this.paymentTypeOptions.length > 0 ? this.paymentTypeOptions[0].value : null
      }
      
    },
    computed: {
      paymentTypeOptions() {
    switch (this.Type) {
      case 'payment':
        return [
          { title: this.$t('golf_booking_confirm_quick_payment'), value: 'payment' },
          { title: this.$t('golf_booking_confirm_quick_payment_print_detail'), value: 'payment-print-detail' },
          { title: this.$t('golf_booking_confirm_quick_payment_print_sum'), value: 'payment-print-sum' }
        ];
      case 'publish':
        return [
          { title: this.$t('golf_booking_confirm_quick_publish'), value: 'publish' },
          { title: this.$t('golf_booking_confirm_quick_publish_print_detail'), value: 'publish-print-detail' },
          { title: this.$t('golf_booking_confirm_quick_publish_print_sum'), value: 'publish-print-sum' }
        ];
      case 'checkout':
        return [
          { title: this.$t('golf_booking_confirm_quick_checkout'), value: 'checkout' },
          { title: this.$t('golf_booking_confirm_quick_checkout_print_detail'), value: 'checkout-print-detail' },
          { title: this.$t('golf_booking_confirm_quick_checkout_print_sum'), value: 'checkout-print-sum' }
        ];
      default:
        return [];
    }
  },
    headerTitleModal() {
      switch (this.Type) {
        case 'payment':
          return this.$t('golf_booking_confirm_quick_payment_print_title');
        case 'publish':
          return this.$t('golf_booking_confirm_quick_publish_print_title');
        case 'checkout':
          return this.$t('golf_booking_confirm_quick_checkout_print_title');
        default:
        return '';
      }
    }

   
    },
    methods: {
      open(item) {
        this.dialog = true
        this.item = item
      },
      close() {
        this.cancelDialog()
        this.dialog = false
      },
      confirmDialog() {
        //this.removeInvoice_and_PaymentDetail_api_DPM09()

        this.$emit('event', { type: this.paymentAction })
        this.dialog = false
        
      },
      cancelDialog() {
        this.dialog = false

      },
      showListDetailInvoice(){
      this.isShowDetailListInvoice = ! this.isShowDetailListInvoice
    },
     
    async removeInvoice_and_PaymentDetail_api_DPM09() {
        this.isLoading = true
      const body = {
        PaymentId: this.listPayment.map(item => item.Id),
        IsDeletePaymentDetail: true,
      }
      await booking.api_DPM09(body)
      .then(async response => {
        this.showResToast(response)
        if (response.Status === '200' || (response.Status === '400' && response.Messages[0].Code ==='E.DPM09.C06')) {
          this.dialog = false
          this.$emit('event', { type: 'after-quick_action_delete_payment' })
          // this.$emit('closePopup', true)
        }
      })
      this.isLoading = false
    },
    },
  }
  </script>
  <style lang="scss" >
  #modal-confirm-quick-payment {
    .modal-content {
        width: 600px !important;
    }
    .truncate-label .vs__selected {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%; /* đảm bảo không tràn ra ngoài */
  }
  .truncate-label .vs__search {
  display: none !important;
}
    .card-body {
      margin-bottom: 20px;
      .confirm-span {
      margin-bottom: 15px;
    }
    }
    .block-header {
      .title-modal {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 21px;
      }
    }
    .color-primary {
      color: #114A9F;
    }
  
    .w-50 {
      width: 65px !important;
    }
  
    .color-warning {
      color: #FF9F43;
    }
    .header-text{
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid rgba(34, 41, 47, 0.05);
        padding-bottom: 0.6rem;
    }
    .header-banner{
        background-color: #e2e9f3;
        color: #114A9F !important;
        .header-banner-title {
            color: #114A9F !important;
        }
    }
    
    
    
  }
  </style>